/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useListenSize from '../../hooks/useListenSize';
import ChevronRight from '../../assets/img/chevron-right.svg';

/**
 * data - { title: string, content: React.ReactNode }
 * One independent, self-contained accordion row. No chained/linked questions.
 */
export const Accordion = ({ data }) => {
  const [isActive, setIsActive] = useState(false);

  useListenSize(isActive);

  return (
    <div className="k-accordion-item">
      <div tabIndex="0" role="button" className="k-accordion-title" onClick={() => setIsActive(!isActive)}>
        <div>{data.title}</div>
        <img
          src={ChevronRight}
          alt="chevron"
          className={`k-accordion-arrow${isActive ? ' k-accordion-arrow-active' : ''}`}
        />
      </div>
      {isActive && <div className="k-accordion-content">{data.content}</div>}
    </div>
  );
};

Accordion.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    content: PropTypes.node.isRequired,
  }).isRequired,
};
